import './oregonzoo/style';
import FormStructure from './oregonzoo/form_structure';

export default FormStructure;